
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training/courses",
      function () {
        return require("private-next-pages/training/courses/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training/courses"])
      });
    }
  